import configureStore from './configure'

const createInitialState = () => {}
const store = configureStore(createInitialState())

export default store



// WEBPACK FOOTER //
// ./src/state/store/index.js